import { render, staticRenderFns } from "./zhuyuan_list.vue?vue&type=template&id=f7d268ec&scoped=true&"
import script from "./zhuyuan_list.vue?vue&type=script&lang=js&"
export * from "./zhuyuan_list.vue?vue&type=script&lang=js&"
import style0 from "./zhuyuan_list.vue?vue&type=style&index=0&id=f7d268ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7d268ec",
  null
  
)

export default component.exports